import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollLayouts } from "./components/RollLayouts";

export const RollLayoutsPage = () => {
	return (
		<>
			<HelmetDexteel title="Roll Layouts" />
			<RollLayouts />
		</>
	);
};
